export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7386.ffb5568e.jpg";